import { Capacitor } from "@capacitor/core";

export const isNativeIOS = Capacitor.getPlatform() === "ios";
export const platform = Capacitor.getPlatform();

// The native shell runs on capacitor://localhost, so email links must point at the real site.
export const webOrigin = isNativeIOS ? process.env.REACT_APP_BACKEND_URL : window.location.origin;

export const APPLE_SUBSCRIPTIONS_URL = "https://apps.apple.com/account/subscriptions";

// Universal links (e.g. magic-link emails) open the app — route them in-app.
export const listenForDeepLinks = async (navigate) => {
  if (!isNativeIOS) return;
  const { App } = await import("@capacitor/app");
  App.addListener("appUrlOpen", ({ url }) => {
    try {
      const u = new URL(url);
      navigate(`${u.pathname}${u.search}${u.hash}`);
    } catch { /* malformed url — ignore */ }
  });
};
